// extracted by mini-css-extract-plugin
export default {"main":"styles_main__RLyzm","ldsRipple":"styles_ldsRipple__4svI7","message":"styles_message__wXXPs"};